/* ==========================================================================
   Header Animation
   ========================================================================== */

// ...

import gsap from "gsap";
import SplitText from "gsap/SplitText";
import ScrollTrigger from "gsap/ScrollTrigger";
import { splitColor } from "gsap/all";

let innerSplit: null | SplitText = null;

function heroReveal() {
  gsap.registerPlugin(SplitText, ScrollTrigger);
  gsap.config({ nullTargetWarn: false });

  function kill() {
    splitTextTimeline.clear().time(0);
    innerSplit.revert();
  }

  const innerSplit = new SplitText(".hero-reveal", {
      type: "chars words",
    }),
    splitTextTimeline = gsap.timeline();

  if (innerSplit instanceof SplitText) {
    innerSplit.revert();
  }

  innerSplit.split({ type: "chars words", wordsClass: "hero-split" });
  gsap.set(innerSplit.chars, { yPercent: 0 });
  splitTextTimeline.from(innerSplit.chars, {
    delay: 0.5,
    yPercent: 105,
    duration: 0.8,
    stagger: 0.02,
    ease: "power4",
  });
  splitTextTimeline.play();
}

function debounce(func: any) {
  var timer: any;
  return function (event: any) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
}

window.addEventListener("load", function () {
  heroReveal();
});
